<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <div class="list">
          <el-table :data="orderList" style="width: 100%">
            <el-table-column label="订单类型">
              <template slot-scope="scope">
                <div class="item">
                  <img :src="productList[scope.row.userFuncType].img" alt />
                  <div class="info">
                    <p class="title">
                      {{ productList[scope.row.userFuncType].name }}
                    </p>
                    <p class="desc">
                      {{ productList[scope.row.userFuncType].content }}
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="状态">
                            <template slot-scope="scope">
                                <div
                                    class="el-link"
                                    :class="scope.row.userFuncStatus == 30 ? 'el-link--primary' : scope.row.userFuncStatus == 20 ? 'el-link--warning' : scope.row.userFuncStatus == 11 ? 'el-link--danger' : 'el-link--danger'"
                                >{{scope.row.userFuncStatus == 30 ? '正常' : scope.row.userFuncStatus == 20 ? '试用' : scope.row.userFuncStatus == 11 ? '过期' : '关闭'}}</div>
                            </template>
                        </el-table-column> -->
            <el-table-column label="开通时间">
              <template slot-scope="scope">
                <div>{{ scope.row.userFuncOpenTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="到期时间">
              <template slot-scope="scope">
                <div>{{ scope.row.userFuncExpireTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div
                  class="float-right"
                  v-if="scope.row.userFuncType != 4 && scope.row.userFuncType != 5"
                >
                  <el-button
                    size="small"
                    type="primary"
                    @click="renew(scope.row.userFuncType)"
                    plain
                    >续费</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getFuncList } from "@/api";
import request from "@/utils/request";
export default {
  data() {
    return {
      orderList: [],
      productList: {
        1: {
          img: `${request.baseUrl}/images/edcmanage/easyBack/func-type1.png`,
          name: "外卖功能",
          content: "实现回头客营销",
        },
        2: {
          img: `${request.baseUrl}/images/edcmanage/easyBack/func-type2.png`,
          name: "扫码点餐",
          content: "降低人工成本",
        },
        3: {
          img: `${request.baseUrl}/images/edcmanage/easyBack/func-type3.png`,
          name: "套餐开通",
          content: "外卖+点餐双管齐下",
        },
        4: {
          img: require("@/assets/img/marketing/func-type4.png"),
          name: "智慧数字经营小程序",
          content: "智慧数字经营",
        },
        5: {
          img: require(`@/assets/img/marketing/func-type5.png`),
          name: "智慧经营连锁店",
          content: "连锁店",
        },
      },
    };
  },
  computed: {
    ...mapState({}),
  },
  mounted() {
    getFuncList().then((res) => {
      if (res.code == 1) {
        this.orderList = res.data;
      }
    });
  },
  methods: {
    renew(id) {
      this.$router.push({
        path: "/marketing/order",
        query: {
          userFuncType: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
    .item {
      display: flex;
      width: 260px;
      height: 54px;
      align-items: center;
      cursor: pointer;
      transition: all 0.5s;
      & > img {
        width: 44px;
        height: 44px;
        margin: 0 10px 0 0;
        object-fit: contain;
      }
      .info {
        & > p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 180px;
        }
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #333333;
          margin-bottom: 12px;
          font-weight: bold;
        }
        .desc {
          font-size: 12px;
          line-height: 12px;
          color: #999999;
        }
      }
    }
  }
}
</style>
